import { FileData } from "./claims";

export class ClaimsUploadFile {
    
    public title: string;
    public typeFiles: string;
    public typeFilesShowClient: string;
    public document: number = 0;
    public documentType: string = "";
    public uploads: FileData[] = [];
    public required: boolean;
    
    constructor(title: string, typeFiles: string,typeFilesShowClient: string,  required: boolean = true){
        this.title = title;
        this.typeFiles = typeFiles;
        this.typeFilesShowClient = typeFilesShowClient;
        this.required = required;
    }
}